import React from 'react'

export const TenantManagement = (): JSX.Element => {
  return <div>Tenant Management</div>
}
